import { compact, orderBy, uniq } from "lodash";
import { InventoryItem } from "../Generated/graphql";

export const formatExcelData = (rawData: InventoryItem[]) => {
  const total = rawData.find((x) => x.productNumber === "Total værdi")!;

  const productData = rawData.filter(
    (item) => item.productNumber !== "Total værdi"
  );

  const sortedData = orderBy(productData, (x) => x.category);

  const readyData = [...sortedData, total];

  return readyData.map((d) => {

    const fixedPrice =
      d && d.price && d.price.toFixed(2) ? d.price.toFixed(2) : "0";

    if (d.productNumber === "Total værdi") {
      return {
        "Produkt nummer": d.productNumber,
        Navn: " ",
        Antal: " ",
        Værdi: parseFloat(fixedPrice),
      };
    }

    const name = d.name;
    const category = d.category;

    const safeAmount = d && d.amount ? d.amount : 0;

    const averagePrice = fixedPrice && parseFloat(fixedPrice) > 0 && (parseFloat(fixedPrice) / safeAmount).toFixed(2) ? (parseFloat(fixedPrice) / safeAmount).toFixed(2) : "0";

    return {
      "Produkt nummer": d.productNumber,
      Navn: name,
      Beskrivelse: d.description,
      Kategori: category,
      Antal: d.amount,
      "Pris pr. stk.": parseFloat(averagePrice),
      Værdi: parseFloat(fixedPrice),
    };
  });
};

/**
 * Returns data grouped by category for multi-sheet Excel export.
 * Each entry has a sheetName and rows array.
 */
export const formatExcelDataByCategory = (rawData: InventoryItem[]) => {
  const total = rawData.find((x) => x.productNumber === "Total værdi");

  const productData = rawData.filter(
    (item) => item.productNumber !== "Total værdi"
  );

  const categories = uniq(compact(productData.map((d) => d.category))).sort();

  const formatItem = (d: InventoryItem) => {
    const fixedPrice =
      d && d.price && d.price.toFixed(2) ? d.price.toFixed(2) : "0";
    const safeAmount = d && d.amount ? d.amount : 0;
    const averagePrice =
      fixedPrice && parseFloat(fixedPrice) > 0 && safeAmount > 0
        ? (parseFloat(fixedPrice) / safeAmount).toFixed(2)
        : "0";

    return {
      "Produkt nummer": d.productNumber,
      Navn: d.name,
      Beskrivelse: d.description,
      Kategori: d.category,
      Antal: d.amount,
      "Pris pr. stk.": parseFloat(averagePrice),
      Værdi: parseFloat(fixedPrice),
    };
  };

  const sheets: { sheetName: string; rows: Record<string, any>[] }[] = [];

  // "Total" sheet with all items + total row
  const allRows = orderBy(productData, (x) => x.category).map(formatItem);
  if (total) {
    const totalPrice = total.price ? total.price.toFixed(2) : "0";
    allRows.push({
      "Produkt nummer": "Total værdi",
      Navn: " ",
      Beskrivelse: " ",
      Kategori: " ",
      Antal: " " as any,
      "Pris pr. stk.": " " as any,
      Værdi: parseFloat(totalPrice),
    });
  }
  sheets.push({ sheetName: "Total", rows: allRows });

  // Per-category sheets
  for (const category of categories) {
    const categoryItems = orderBy(
      productData.filter((d) => d.category === category),
      (x) => x.name
    );
    const rows = categoryItems.map(formatItem);

    // Add subtotal for this category
    const categoryTotal = categoryItems.reduce(
      (sum, item) => sum + (item.price || 0),
      0
    );
    rows.push({
      "Produkt nummer": `Total - ${category}`,
      Navn: " ",
      Beskrivelse: " ",
      Kategori: " ",
      Antal: " " as any,
      "Pris pr. stk.": " " as any,
      Værdi: parseFloat(categoryTotal.toFixed(2)),
    });

    // Truncate sheet name to 31 chars (Excel limit)
    const sheetName = category.length > 31 ? category.substring(0, 31) : category;
    sheets.push({ sheetName, rows });
  }

  return sheets;
};
